import { useUser } from "../../../hooks/react-query/useUser";
import { useRedirectAnonymous } from "../../../hooks/auth/useRedirectAnonymous";
import { useAppointmentList } from "../../../hooks/react-query/useAppointmentList";
import { Container } from "../../../components/UI/container/Container";
import { AppointmentItem } from "../../../components/pages/user/appointments/AppointmentItem";
import { MyH1 } from "../../../components/UI/my-h1/MyH1";
import { IconCalendarEvent } from "@tabler/icons";
import { useColors } from "../../../hooks/colors/useColors";
import { Badge, Loader, Tabs } from "@mantine/core";
import { isMobile } from "react-device-detect";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { MyHead } from "../../../components/pages/MyHead";
import { Fragment } from "react";
import { BackToProfile } from "../../../components/pages/user/BackToProfile";
import { Footer } from "../../../components/pages/homepage/footer/Footer";

// @ts-ignore
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      // Will be passed to the page component as props
    },
  };
}

function UserAppointmentPage() {
  const redirect = useRedirectAnonymous();
  const { user } = useUser();
  const { appointmentData, appointmentsAreLoading } = useAppointmentList();
  const { colors } = useColors();
  const { t } = useTranslation("common");

  return (
    <Fragment>
      <MyHead title={t("user.manageApps")} description={t("user.manageApps")} />
      <BackToProfile />
      <MyH1 centerText className="pt-8 text-4xl">
        {t("user.manageApps")}
      </MyH1>
      {user && (
        <Container noHeight>
          {(typeof appointmentData === "undefined" ||
            appointmentData.length === 0) &&
            !appointmentsAreLoading && (
              <div className="flex flex-col items-center justify-center h-full">
                <IconCalendarEvent
                  opacity={0.8}
                  stroke={1}
                  size={isMobile ? 360 : "30rem"}
                  color={colors.primary}
                />
              </div>
            )}
          {appointmentsAreLoading && (
            <div className="flex flex-col items-center justify-center">
              <Loader />
            </div>
          )}
          {appointmentData && appointmentData.length > 0 && (
            <Tabs defaultValue="premise" className="mb-4">
              <Tabs.List>
                <Tabs.Tab
                  value="premise"
                  className="!text-2xl"
                  rightSection={
                    appointmentData.filter((app) => !app.appointment.online)
                      .length > 0 ? (
                      <Badge
                        className="!text-xl !p-4"
                        style={{ backgroundColor: colors.secondary }}
                      >
                        {
                          appointmentData.filter(
                            (app) => !app.appointment.online
                          ).length
                        }
                      </Badge>
                    ) : undefined
                  }
                >
                  {t("appointments.onPremise")}
                </Tabs.Tab>
                <Tabs.Tab
                  value="online"
                  className="!text-2xl"
                  rightSection={
                    appointmentData.filter((app) => app.appointment.online)
                      .length > 0 ? (
                      <Badge
                        className="!text-xl !p-4"
                        style={{ backgroundColor: colors.secondary }}
                      >
                        {
                          appointmentData.filter(
                            (app) => app.appointment.online
                          ).length
                        }
                      </Badge>
                    ) : undefined
                  }
                >
                  Online
                </Tabs.Tab>
              </Tabs.List>
              <Tabs.Panel value="premise">
                {appointmentData
                  .filter((app) => !app.appointment.online)
                  .map((appointmentDTO, index) => {
                    return (
                      <AppointmentItem
                        appointmentDTO={appointmentDTO}
                        key={appointmentDTO.appointment.id}
                      />
                    );
                  })}
                {appointmentData &&
                  appointmentData.filter((app) => !app.appointment.online)
                    .length === 0 && (
                    <div className="flex flex-col items-center justify-center h-full">
                      <IconCalendarEvent
                        opacity={0.8}
                        stroke={1}
                        size={isMobile ? 360 : "30em"}
                        color={colors.primary}
                      />
                    </div>
                  )}
              </Tabs.Panel>
              <Tabs.Panel value="online">
                {appointmentData
                  .filter((app) => app.appointment.online)
                  .map((appointmentDTO, index) => {
                    return (
                      <AppointmentItem
                        appointmentDTO={appointmentDTO}
                        key={appointmentDTO.appointment.id}
                      />
                    );
                  })}
                {appointmentData &&
                  appointmentData.filter((app) => app.appointment.online)
                    .length === 0 && (
                    <div className="flex flex-col items-center justify-center h-full">
                      <IconCalendarEvent
                        opacity={0.8}
                        stroke={1}
                        size={isMobile ? 360 : "30em"}
                        color={colors.primary}
                      />
                    </div>
                  )}
              </Tabs.Panel>
            </Tabs>
          )}
        </Container>
      )}
      <Footer isVisible />
    </Fragment>
  );
}

export default UserAppointmentPage;
